// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3Yyxe","header":"Messages_header__cXWsh"};